import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import RTISection4AdministrationEle6Pg from './RTISection4AdministrationEle6Pg';
import RTISection4AdministrationEle5Pg from './RTISection4AdministrationEle5Pg';
import RTISection4AdministrationEle4Pg from './RTISection4AdministrationEle4Pg';
import RTISection4AdministrationEle3Pg from './RTISection4AdministrationEle3Pg';
import RTISection4AdministrationEle2Pg from './RTISection4AdministrationEle2Pg';
import RTISection4AdministrationEle1Pg from './RTISection4AdministrationEle1Pg';

function RTISection4AdministrationPg() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Administration"/>
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>Right to Information</h1>
                    </div> 

                    <div className="border">
                            <div className='ms-3'>
                                <h4> RTI Section4</h4>
                                <Tab.Container id="left-tabs-example" defaultActiveKey="rtisec1">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column" >
            <Nav.Item >
              <Nav.Link eventKey="rtisec1" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> Organisation and Functions </Nav.Link>
            </Nav.Item>
            <Nav.Item> 
              <Nav.Link eventKey="rtisec2" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> Budget and Programme  </Nav.Link>
            </Nav.Item>
            <Nav.Item> 
              <Nav.Link eventKey="rtisec3" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> BPublicity and Public Interface </Nav.Link>
            </Nav.Item>
            <Nav.Item> 
              <Nav.Link eventKey="rtisec4" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> E-Governance </Nav.Link>
            </Nav.Item>
            <Nav.Item> 
              <Nav.Link eventKey="rtisec5" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> Information as may be Prescribed </Nav.Link>
            </Nav.Item>
            <Nav.Item> 
              <Nav.Link eventKey="rtisec6" style={{backgroundColor:"#97222B",fontWeight:"bold",color:"#FFF", marginBottom:"5px"}}> Information disclosed on own initiative </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={9}>
          <Tab.Content>
            <Tab.Pane eventKey="rtisec1"><RTISection4AdministrationEle1Pg/></Tab.Pane>
            <Tab.Pane eventKey="rtisec2"><RTISection4AdministrationEle2Pg/></Tab.Pane>
            <Tab.Pane eventKey="rtisec3"><RTISection4AdministrationEle3Pg/></Tab.Pane>
            <Tab.Pane eventKey="rtisec4"><RTISection4AdministrationEle4Pg/></Tab.Pane>
            <Tab.Pane eventKey="rtisec5"><RTISection4AdministrationEle5Pg/></Tab.Pane>
            <Tab.Pane eventKey="rtisec6"><RTISection4AdministrationEle6Pg/></Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
                            </div>
                    </div> 
                </div>
                
            </section>
        </>
    );
}

export default RTISection4AdministrationPg;